import React from 'react';
import { LinkWrapper } from '../../components/BaseComp';
import s from './UserReport.scss';

export const UserReport = () => {
    return (
        <div className={s.container} data-spm="user-feedback">
            <div>
                <img className={s.entrance} src="http://statics.itc.cn/sohu-homepage/classicright.png" />
            </div>
             <LinkWrapper className={[s.btn, s.report].join(' ')} href="http://fbp.sohu.com/fbp/problem/advice?product=pc">
                <p className={s.btnText}>用户<br />反馈</p>
            </LinkWrapper>
            <button className={s.btn} id="scroll-top" style={{display: 'none'}}>
                <i className='bicon-arrow'/>
            </button>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/UserReport/index.tsx